import { Component, ElementRef, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatDialogModule,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-update-lpr-credential-status',
  standalone: true,
  imports: [MatDialogModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatButtonModule],
  templateUrl: './dialog-update-lpr-credential-status.component.html',
  styleUrl: './dialog-update-lpr-credential-status.component.scss',
})
export class DialogUpdateLprCredentialStatusComponent {
  constructor(
    public _dialogRef: MatDialogRef<DialogUpdateLprCredentialStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
